(function ($) {
    $(document).ready(function () {
        $('.select-dropdown-link select').on('change', function () {
            var redirect_url = $(this).val();
            if ($(this).find('option:selected').attr('linktype') === 'external') {
                window.open(sanitizeHtmlStrings(redirect_url), '_blank');
            } else {
                document.location.href = window.encodeURI(sanitizeHtmlStrings(decodeURI(redirect_url)));
            }
        });
    });
}(window.jQuery));

// Analytics

analytics.eventConfig.push(
    {
        "target": ".form-group .select-wrapper:not(.noTriggerAnalyticsEvent)",
        "codeId": "fo02",
        "events": [
            {
                "eventTarget": ".form-control",
                "eventType": "change",
                "tags": {
                    "componentId": "fo02",
                    "componentName": "select box",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": [
                        {
                            "rule": "$(context).parents('.product-selector-form').length > 0",
                            "value": "dropdown select box"
                        },
                        {
                            "rule": "true",
                            "value": "select box link"
                        }
                    ],
                    "event": [
                        {
                            "rule": "$(context).find(':selected').attr('linktype') == 'mailto'",
                            "value": "contact"
                        },
                        {
                            "rule": "$(context).find(':selected').val().toLowerCase().search('pds') !== -1 || $(context).find(':selected').val().toLowerCase().search('psims') !== -1 || $(context).find(':selected').attr('linktype') == 'media'",
                            "value": "download"
                        },
                        {
                            "rule": "$(context).find(':selected').attr('linktype') == 'internal'",
                            "value": "navigation"
                        },
                        {
                            "rule": "$(context).parents('.product-selector-form').length > 0",
                            "value": "product"
                        },
                        {
                            "rule": "true",
                            "value": "outbound"
                        }
                    ],
                    "eventType": [
                        {
                            "rule": "$(context).find(':selected').attr('linktype') == 'mailto'",
                            "value": "click to email"
                        },
                        {
                            "rule": "$(context).find(':selected').val().toLowerCase().search('pds') !== -1",
                            "value": "pds download click"
                        },
                        {
                            "rule": "$(context).find(':selected').val().toLowerCase().search('psims') !== -1",
                            "value": "sds download click"
                        },
                        {
                            "rule": "$(context).find(':selected').attr('linktype') == 'media'",
                            "value": "other media asset click"
                        },
                        {
                            "rule": "$(context).find(':selected').attr('linktype') == 'internal'",
                            "value": "select box internal navigation click"
                        },
                        {
                            "rule": "$(context).parents('.product-selector-form').length > 0",
                            "value": "ps dropdown selection click"
                        },
                        {
                            "rule": "true",
                            "value": "outbound click"
                        }
                    ],
                    "fileName": "",
                    "titleText": ""
                }
            }, {
                "eventTarget": "triggerOnChangeEvent",
                "eventType": "change",
                "tags": {
                    "componentId": "fo02",
                    "componentName": "select box",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": [
                        {
                            "rule": "$(context).parents('.product-selector-form').length > 0",
                            "value": "dropdown select box"
                        },
                        {
                            "rule": "true",
                            "value": "select box link"
                        }
                    ],
                    "event": [
                        {
                            "rule": "$(context).find(':selected').attr('linktype') == 'mailto'",
                            "value": "contact"
                        },
                        {
                            "rule": "$(context).find(':selected').val().toLowerCase().search('pds') !== -1 || $(context).find(':selected').val().toLowerCase().search('psims') !== -1 || $(context).find(':selected').attr('linktype') == 'media'",
                            "value": "download"
                        },
                        {
                            "rule": "$(context).find(':selected').attr('linktype') == 'internal'",
                            "value": "navigation"
                        },
                        {
                            "rule": "$(context).parents('.product-selector-form').length > 0",
                            "value": "product"
                        },
                        {
                            "rule": "true",
                            "value": "outbound"
                        }
                    ],
                    "eventType": [
                        {
                            "rule": "$(context).find(':selected').attr('linktype') == 'mailto'",
                            "value": "click to email"
                        },
                        {
                            "rule": "$(context).find(':selected').val().toLowerCase().search('pds') !== -1",
                            "value": "pds download click"
                        },
                        {
                            "rule": "$(context).find(':selected').val().toLowerCase().search('psims') !== -1",
                            "value": "sds download click"
                        },
                        {
                            "rule": "$(context).find(':selected').attr('linktype') == 'media'",
                            "value": "other media asset click"
                        },
                        {
                            "rule": "$(context).find(':selected').attr('linktype') == 'internal'",
                            "value": "select box internal navigation click"
                        },
                        {
                            "rule": "$(context).parents('.product-selector-form').length > 0",
                            "value": "ps dropdown selection click"
                        },
                        {
                            "rule": "true",
                            "value": "outbound click"
                        }
                    ],
                    "fileName": "",
                    "titleText": ""
                }
            }, {
                "eventTarget": "triggerOnChangeEventTypeAhead",
                "eventType": "change",
                "tags": {
                    "componentId": "fo02",
                    "componentName": "select box",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "",
                    "event": "",
                    "eventType": "",
                    "fileName": "",
                    "titleText": ""
                }
            }
        ]
    },
)